module.exports = __webpack_public_path__ + "img/coupon_5.f7efbc06.png";